"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fiCommonTranslations = void 0;
/* eslint-disable */
exports.fiCommonTranslations = {
    product: {
        unit: {
            g: 'g',
            kg: 'kg',
            ml: 'ml',
            cl: 'cl',
            dl: 'dl',
            l: 'l',
            m: 'm',
            ras: 'ras',
            tbl: 'tbl',
            plo: 'plo',
            tlk: 'tlk',
            pss: 'pss',
            kpl: 'kpl',
            nip: 'nip'
        },
        editProduct: 'Muokkaa tuotetta',
        customer: 'Asiakas',
        selectCustomer: 'Valitse asiakas',
        addProduct: 'Lisää tuote',
        removeProduct: 'Poista tuote',
        scaleNumber: 'Vaakanumero',
        price: 'Hinta',
        country: 'Alkuperämaa',
        packageSize: 'Pakkauskoko',
        packageUnit: 'Yksikkö',
        sellingUnit: 'Myyntiyksikkö',
        sellingPrice: 'Myyntihinta',
        discountPrice: 'Tarjoushinta',
        discount: 'Tarjous',
        class: 'Luokka',
        description: 'Kuvaus',
        imageNotFound: 'Kuvaa ei löydy',
        packageUnitTooltip: 'Pakkausyksikkö, eli tuotteen kokonaispainon tai tilavuuden yksikkö, esim 500 g',
        sellingUnitTooltip: 'Tuotteen myyntiyksikkö, eli esimerkiksi 1.49€ kg tai kpl',
        productImage: 'Tuotekuva',
        details: 'Tuotetiedot',
        delete: 'Poista tuote',
        deleteConfirm: 'Oletko varma, että haluat poistaa tuotteen {{name}}? Tätä toimintoa ei voi peruuttaa',
        selectTemplate: 'Mallipohja',
        discountValid: 'Vapaa tekstikenttä',
        discountValidHelper: 'esim. Tarjous voimassa 2.5-2.6.2020\', \'Rajoitettu erä 2 kpl / talous.',
        comparisonUnit: 'Vertailuyksikkö',
        comparisonUnitHelper: 'Vertailuyksikkö, esim. 1,90€ / kg',
        discountBatch: 'Määräalennus',
        discountBatchHelper: 'Kappalemäärä, jos esim 3 kpl tarjoushintaan',
        deposit: 'Pantti',
        depositHelper: 'Jos panttituote',
        tag: {
            organic: 'Luomu',
            local: 'Läheltä',
            discount: 'Tarjous',
            new: 'Uutuus'
        },
        tags: 'Tägit',
        selectOneTag: 'Valitse vain yksi*',
        isPrefilled: "Tuotteen tietoja on ennalta täytetty. Varimista, että tiedot ovat oikein."
    }
};
//# sourceMappingURL=fi.js.map